import { useEffect, useState } from "react";
import api from "../../lib/api";
import { Card } from "../../components/ui/Card";
import Input from "../../components/ui/Input";
import Button from "../../components/ui/Button";

export default function LoyaltyProgram() {
  const [program, setProgram] = useState(null);
  const [form, setForm] = useState({ reward_title: "", rules: "1 stamp = 1 visit", stamps_required: 10 });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api
      .get("/owner/loyalty-program")
      .then(({ data }) => {
        setProgram(data);
        if (data) setForm({ reward_title: data.reward_title, rules: data.rules || "", stamps_required: data.stamps_required });
      })
      .catch(() => {});
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { data } = await api.post("/owner/loyalty-program", form);
      setProgram(data);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="max-w-xl">
      <h1 className="mb-2 font-montserrat text-2xl font-bold text-slate-900">Loyalty program</h1>
      <p className="mb-6 text-sm text-muted-foreground">
        Customers collect a stamp every time an appointment is marked completed. Reach the target and
        the card completes automatically.
      </p>

      {program && (
        <Card className="mb-6 p-4">
          <p className="text-sm text-muted-foreground">Currently active</p>
          <p className="font-semibold text-slate-900">{program.reward_title}</p>
          <p className="text-sm text-muted-foreground">{program.stamps_required} stamps · {program.rules}</p>
        </Card>
      )}

      <form onSubmit={submit} className="space-y-4">
        <Input
          placeholder="Reward title (e.g. Free haircut after 10 visits)"
          required
          value={form.reward_title}
          onChange={(e) => setForm({ ...form, reward_title: e.target.value })}
        />
        <Input
          placeholder="Rules"
          value={form.rules}
          onChange={(e) => setForm({ ...form, rules: e.target.value })}
        />
        <Input
          type="number"
          min={1}
          max={50}
          placeholder="Stamps required"
          required
          value={form.stamps_required}
          onChange={(e) => setForm({ ...form, stamps_required: e.target.value })}
        />
        <Button type="submit" disabled={saving}>{saving ? "Saving…" : program ? "Replace program" : "Launch program"}</Button>
      </form>
    </div>
  );
}
